/* eslint-disable react/prop-types */

import React, { useEffect, useState } from 'react'
import {
  Card, Form, Button, message, Input, Spin, Space, Row, Col,
} from 'antd'

import {
  SaveOutlined, UploadOutlined, FileImageOutlined, CheckCircleTwoTone,
} from '@ant-design/icons'

import debounce from 'lodash.debounce'

import { useRecoilState } from 'recoil'

import {
  editOrder,
} from '../../../store/atoms'

import UploadButton from '../../component/UploadButton'

import { fetch } from '../../../utils/fetch'
import Quotation from '../../component/Quotation'
import FileUpload from '../../component/FileUpload'

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 14,
  },
}

const OrderHeader = (props) => {
  const {
    orderId, sap, created = false, submitted = false, orderType,

  } = props
  const [isLoading, setIsLoading] = useState(true)
  const [upLoadVisible, setUpLoadVisible] = useState(false)
  const [orderHeaderData, setOrderHeaderData] = useState({})
  const [orderHeaderId, setOrderHeaderId] = useState('')
  const [inputing, setInputing] = useState(false)
  const [visibleStatus, setVisibleStatus] = useState(false)
  const [soldToError, setSoldToError] = useState('')
  const [shipToError, setShipToError] = useState('')
  const [billToError, setBillToError] = useState('')
  const [payerError, setPayerError] = useState('')
  const [soldToErrMes, setSoldToErrMes] = useState('')
  const [shipToErrMes, setShipToErrMes] = useState('')
  const [billToErrMes, setBillToErrMes] = useState('')
  const [payerErrMes, setPayerErrMes] = useState('')

  const [editOrderBtn, setEditOrderBtn] = useRecoilState(editOrder)

  const [form] = Form.useForm()
  const { Search } = Input

  const getHeaderData = async () => {
    await fetch({
      url: `/order/${orderId}/header`,
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((res) => {
      if (res?.data?.success) {
        const headerData = res.data.data
        setOrderHeaderData(headerData)
        setOrderHeaderId(headerData.orderHeaderId)
        if (typeof props.onChangeShipTo === 'function') {
          props.onChangeShipTo()
        }
        if (res.data.data.channel === '11') {
          props.onSetIsFixItemCat(true)
        } else {
          props.onSetIsFixItemCat(false)
        }
      } else {
        console.log('Error:', res.data)
        message.error(res?.data?.message)
      }
      setIsLoading(false)
    })
  }

  const updateHeaderData = async (values) => {
    setVisibleStatus(true)
    setInputing(true)
    setEditOrderBtn(true)
    await fetch({
      method: 'PUT',
      url: `/order/${orderId}/header/${orderHeaderId}`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: values,
    }).then((res) => {
      if (res?.data?.success) {
        if (values.channel === '11') {
          props.onSetIsFixItemCat(true)
        } else {
          props.onSetIsFixItemCat(false)
        }
        getHeaderData()
        setInputing(false)
      } else {
        console.log('Error:', res.data)
        message.error(res?.data?.message)
      }
    })
    setIsLoading(false)
    setTimeout(() => {
      setVisibleStatus(false)
    }, 1200)
  }

  const showUpload = () => {
    getHeaderData()
    setUpLoadVisible(!upLoadVisible)
  }

  const checkCustomer = async (code, chooseAction) => {
    await fetch({
      method: 'GET',
      url: `/sap-service/customer?custCode=${code}&custField=${chooseAction}`,
      headers: {
        'Content-Type': 'application/json',
      },
    }).then(async (res) => {
      if (res?.data?.success) {
        const { data } = res.data
        const updateFieldName = `${chooseAction}Name`
        const newData = {
          ...orderHeaderData,
          [chooseAction]: code,
          [updateFieldName]: data.customerName,
        }
        if (chooseAction === 'shipTo') newData.regCode = data.regCode
        await updateHeaderData(newData)
        if (chooseAction === 'soldTo') {
          setSoldToError('')
          setSoldToErrMes('')
        } else if (chooseAction === 'shipTo') {
          setShipToError('')
          setShipToErrMes('')
        } else if (chooseAction === 'billTo') {
          setBillToError('')
          setBillToErrMes('')
        } else if (chooseAction === 'payer') {
          setPayerError('')
          setPayerErrMes('')
        }
      } else if (chooseAction === 'soldTo') {
        setSoldToError('error')
        setSoldToErrMes(res?.data?.message)
      } else if (chooseAction === 'shipTo') {
        setShipToError('error')
        setShipToErrMes(res?.data?.message)
      } else if (chooseAction === 'billTo') {
        setBillToError('error')
        setBillToErrMes(res?.data?.message)
      } else if (chooseAction === 'payer') {
        setPayerError('error')
        setPayerErrMes(res?.data?.message)
      }
    })
  }

  const callUpdate = debounce(updateHeaderData, 300)

  const onSearch = (code, chooseAction) => {
    checkCustomer(code, chooseAction)
  }

  useEffect(() => {
    if (created) {
      if (sap && orderType === 'PAR') {
        form.setFieldsValue(sap)
        setOrderHeaderData(sap)
        setOrderHeaderId(sap?.orderHeaderId)
        setIsLoading(false)
      } else if (orderType === 'DSB') {
        getHeaderData()
      }
    } else {
      getHeaderData()
    }
  }, [orderId, sap, orderType])

  if (isLoading) {
    return (
      <Spin spinning tip="Loading...">
        <Card
          title="Header"
          type="inner"
          style={{ minHeight: 400 }}
        />
      </Spin>
    )
  }

  return (
    <Form
      {...layout}
      form={form}
      preserve={false}
      layout="horizontal"
      name="order-header-form"
      initialValues={orderHeaderData}
      onValuesChange={callUpdate}
    >
      <Card
        title="Header"
        type="inner"
        extra={(
          <Space>
            {inputing === false
              && visibleStatus
              && !created
              && <><CheckCircleTwoTone twoToneColor="#52c41a" /><span>Saved to Cloud</span></>}
          </Space>
        )}
      >
        {
          !created
            ? (
              <Row gutter={24}>
                {/* Left Col */}
                <Col span={12}>
                  <Form.Item name="salesOrg" label="Sales Organization">
                    <Input />
                  </Form.Item>
                  <Form.Item name="salesOffice" label="Sales Office">
                    <Input />
                  </Form.Item>
                  <Form.Item name="salesGroup" label="Sales Group">
                    <Input />
                  </Form.Item>
                  <Form.Item name="salesEmp" label="Sales Employee">
                    <Input />
                  </Form.Item>
                  <Form.Item name="designer" label="Designer">
                    <Input />
                  </Form.Item>
                  {/* <Form.Item>
                    <></>
                  </Form.Item> */}
                  <Form.Item name="division" label="Division">
                    <Input />
                  </Form.Item>
                  <Form.Item name="channel" label="Channel">
                    <Input />
                  </Form.Item>
                  <Form.Item label="Image">
                    <UploadButton
                      action="Header"
                      editing={!submitted}
                      itemId={null}
                      orderId={orderId}
                      headerId={orderHeaderId}
                    />
                  </Form.Item>
                </Col>
                {/* Right Col */}
                <Col span={12}>
                  {/* Sold-To */}
                  <Form.Item
                    label="Sold-To"
                    validateStatus={soldToError.length > 0 ? soldToError : null}
                    help={soldToErrMes.length > 0 ? soldToErrMes : null}
                  >
                    <Row>
                      <Col md={12} sm={24}>
                        <Search
                          defaultValue={orderHeaderData?.soldTo}
                          onSearch={(e) => { onSearch(e, 'soldTo') }}
                          placeholder="input search text"
                          maxLength={10}
                        />
                      </Col>
                      <Col md={12} sm={24}>
                        {soldToError === '' && (
                          <Form.Item noStyle>
                            <Space>
                              {' '}<span>{orderHeaderData?.soldToName}</span>
                            </Space>
                          </Form.Item>
                        )}
                      </Col>
                    </Row>
                  </Form.Item>
                  {/* Ship-To */}
                  <Form.Item
                    label="Ship-To"
                    validateStatus={shipToError.length > 0 ? shipToError : null}
                    help={shipToErrMes.length > 0 ? shipToErrMes : null}
                  >
                    <Row>
                      <Col md={12} sm={24}>
                        <Search
                          defaultValue={orderHeaderData?.shipTo}
                          onSearch={(e) => { onSearch(e, 'shipTo') }}
                          placeholder="input search text"
                          maxLength={10}
                        />
                      </Col>
                      <Col md={12} sm={24}>
                        {shipToError === '' && (
                          <Form.Item noStyle>
                            <Space>
                              {' '}<span>{orderHeaderData?.shipToName}</span>
                            </Space>
                          </Form.Item>
                        )}
                      </Col>
                    </Row>
                  </Form.Item>
                  {/* Bill-To */}
                  <Form.Item
                    label="Bill-To"
                    validateStatus={billToError.length > 0 ? billToError : null}
                    help={billToErrMes.length > 0 ? billToErrMes : null}
                  >
                    <Row>
                      <Col md={12} sm={24}>
                        <Search
                          defaultValue={orderHeaderData?.billTo}
                          onSearch={(e) => { onSearch(e, 'billTo') }}
                          placeholder="input search text"
                          maxLength={10}
                        />
                      </Col>
                      <Col md={12} sm={24}>
                        {billToError === '' && (
                          <Form.Item noStyle>
                            <Space>
                              {' '}<span>{orderHeaderData?.billToName}</span>
                            </Space>
                          </Form.Item>
                        )}
                      </Col>
                    </Row>
                  </Form.Item>
                  {/* Payer */}
                  <Form.Item
                    label="Payer"
                    validateStatus={payerError.length > 0 ? payerError : null}
                    help={payerErrMes.length > 0 ? payerErrMes : null}
                  >
                    <Row>
                      <Col md={12} sm={24}>
                        <Search
                          defaultValue={orderHeaderData?.payer}
                          onSearch={(e) => { onSearch(e, 'payer') }}
                          placeholder="input search text"
                          maxLength={10}
                        />
                      </Col>
                      <Col md={12} sm={24}>
                        {payerError === '' && (
                          <Form.Item noStyle>
                            <Space>
                              {' '}<span>{orderHeaderData?.payerName}</span>
                            </Space>
                          </Form.Item>
                        )}
                      </Col>
                    </Row>
                  </Form.Item>
                  {/* <Form.Item name="division" label="Division">
                    <Input />
                  </Form.Item>
                  <Form.Item name="channel" label="Channel">
                    <Input />
                  </Form.Item> */}
                  <Form.Item label="Confirm Design">
                    <Quotation
                      orderId={orderId}
                      orderType={orderType}
                    />
                  </Form.Item>
                  <Form.Item label="Terms of Service">
                    <FileUpload
                      orderId={orderId}
                      fileType="terms"
                    />
                  </Form.Item>
                  <Form.Item label="Warranty">
                    <FileUpload
                      orderId={orderId}
                      fileType="warranty"
                    />
                  </Form.Item>
                </Col>
              </Row>
            )
            : (
              <Row gutter={24}>
                {/* Left Col */}
                <Col span={12}>
                  <Form.Item name="salesOrg" label="Sales Org">
                    <span className="ant-form-text">{form.getFieldValue('salesOrg')}</span>
                  </Form.Item>
                  <Form.Item name="salesOffice" label="Sales Office">
                    <span className="ant-form-text">{form.getFieldValue('salesOffice')}</span>
                  </Form.Item>
                  <Form.Item name="salesGroup" label="Sales Group">
                    <span className="ant-form-text">{form.getFieldValue('salesGroup')}</span>
                  </Form.Item>
                  <Form.Item name="salesEmp" label="Sales Employee">
                    <span className="ant-form-text">{form.getFieldValue('salesEmp')}</span>
                  </Form.Item>
                  <Form.Item name="designer" label="Designer">
                    <span className="ant-form-text">{form.getFieldValue('designer')}</span>
                  </Form.Item>
                  <Form.Item name="division" label="Division">
                    <span className="ant-form-text">{form.getFieldValue('division')}</span>
                  </Form.Item>
                  <Form.Item name="channel" label="Channel">
                    <span className="ant-form-text">{form.getFieldValue('channel')}</span>
                  </Form.Item>
                  {/* <Form.Item>
                    <></>
                  </Form.Item> */}
                  {
                    orderType === 'PAR' && (
                      <Form.Item label="Image">
                        <UploadButton
                          action="Header"
                          editing={!submitted}
                          itemId={null}
                          orderId={orderId}
                          headerId={orderHeaderId}
                          submitted={submitted}
                        />
                      </Form.Item>
                    )
                  }

                </Col>
                {/* Right Col */}
                <Col span={12}>
                  <Form.Item name="soldTo" label="Sold-To">
                    <span className="ant-form-text">{form.getFieldValue('soldTo')} {form.getFieldValue('soldToName')}</span>
                  </Form.Item>
                  <Form.Item name="shipTo" label="Ship-To">
                    <span className="ant-form-text">{form.getFieldValue('shipTo')} {form.getFieldValue('shipToName')}</span>
                  </Form.Item>
                  <Form.Item name="billTo" label="Bill-To">
                    <span className="ant-form-text">{form.getFieldValue('billTo')} {form.getFieldValue('billToName')}</span>
                  </Form.Item>
                  <Form.Item name="payer" label="Payer">
                    <span className="ant-form-text">{form.getFieldValue('payer')} {form.getFieldValue('payerName')}</span>
                  </Form.Item>
                  {
                    orderType === 'PAR' && (
                      <>
                        <Form.Item label="Confirm Design">
                          <Quotation
                            orderId={orderId}
                            orderType={orderType}
                          />
                        </Form.Item>
                        <Form.Item label="Terms of Service">
                          <FileUpload
                            orderId={orderId}
                            fileType="terms"
                          />
                        </Form.Item>
                        <Form.Item label="Warranty">
                          <FileUpload
                            orderId={orderId}
                            fileType="warranty"
                          />
                        </Form.Item>
                      </>
                    )
                  }
                </Col>
              </Row>
            )
        }

      </Card>
    </Form>
  )
}

export default OrderHeader

